import type { InboxAgent, QuickReply, Tag } from '@dnx/contracts';
import { queryOptions } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export const tagsQuery = queryOptions({ queryKey: ['tags'], queryFn: () => api<Tag[]>('/tags'), staleTime: 60_000 });
export const quickRepliesQuery = queryOptions({ queryKey: ['quick-replies'], queryFn: () => api<QuickReply[]>('/quick-replies'), staleTime: 60_000 });
export const agentsQuery = queryOptions({ queryKey: ['inbox', 'agents'], queryFn: () => api<InboxAgent[]>('/inbox/agents'), staleTime: 60_000 });

/** Paleta das etiquetas (fixa: bom contraste com texto branco nos dois temas). */
export const TAG_COLORS = ['#0F766E', '#2563EB', '#7C3AED', '#C026D3', '#DC2626', '#EA580C', '#CA8A04', '#4B5563'];
